import LoginBox from "./LoginBox"
import TrackingBox from "./TrackingBox"
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Services = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);

            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }, 100);
            }
        }
    }, [location]);

  return (
    <>
      <section>
        <div className="container-fluid">
          <img src="images/innerbanner.webp" className='img-fluid' alt="" />
        </div>
      </section>

      {/* MAIN SECTION */}
      <section className="main-section">
        <div className="container">
          <div className="row g-4">

            {/* SIDEBAR */}
            <div className="col-lg-3">

              <TrackingBox />
              <LoginBox />

              {/* Contact */}
              <div className="contact-card">
                <div className="contact-title">Contact</div>

                <div className="contact-item">
                  <div className="contact-icon phone">
                    <i className="fa fa-phone"></i>
                  </div>
                  <a href="tel:01141606842">+91 96672 33072</a>
                </div>

                <div className="contact-item">
                  <div className="contact-icon email">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <a href="#">oxford_express@yahoo.co.in</a>
                </div>

                <div className="contact-item">
                  <div className="contact-icon email">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <a href="#">info@oxfordexp.com</a>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-9">

              {/* Welcome */}
              <div className="bg-white rounded-3 p-4 mb-4 shadow-sm">

                <h2 className="section-title">
                  SERVICES
                </h2>

                <p className="welcome-text">
                  We make sure your documents, parcels and freight are delivered safely and on-time using our integrated air and road networks.We make sure your documents, parcels and freight are delivered safely and on-time using our integrated air and road networks.
                </p>
              </div>

              {/* Services + News */}
              <div className="row g-3">

                {/* Services */}
                 <div className="col-md-12" id="oxford-engineering" style={{ scrollMarginTop: "120px" }}>
                  <div className="services-box">
                    <div className="services-box-header">Oxford Engineering<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">We design, implement and operate complex supply chain solutions on a national, regional for medium to large enterprises.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12" id="express-services" style={{ scrollMarginTop: "120px" }}>
                  <div className="services-box">
                    <div className="services-box-header">Express Services<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">Oxford Engineering is the Best provider of express business to business delivery services. OXFORD provides on-demand, time-definite and day-certain delivery of documents, parcels and freight.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" id="domestic-services" style={{ scrollMarginTop: "120px" }}>
                  <div className="services-box">
                    <div className="services-box-header">Domestic Services<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">Spanning the length and breadth of the Indian subcontinent by land and air, Oxford presents a comprehensive array of solutions for all your express requirements.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12" id="time-definite" style={{ scrollMarginTop: "120px" }}>
                  <div className="services-box">
                    <div className="services-box-header">Time Definite Services<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">Designed for urgent shipments offering total control over time-critical requirements.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" id="sameday" style={{ scrollMarginTop: "120px" }}>
                  <div className="services-box">
                    <div className="services-box-header">Sameday<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">For your time critical deliveries, Oxford Sameday will offer a delivery solution that ensures that your urgent consignment is delivered door-to-door the very same day.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="services-box">
                    <div className="services-box-header">Service Features<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">For your time critical deliveries, Oxford Sameday will offer a delivery solution that ensures that your urgent consignment is delivered door-to-door the very same day.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* STATS STRIP */}
      <section className="stats-strip">
        <div className="container">
          <div className="row g-0 text-center">

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">4.5L+</div>
              <div className="stat-label">Packets / Month</div>
            </div>

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Cities Covered</div>
            </div>

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">35+</div>
              <div className="stat-label">Years Experience</div>
            </div>

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Happy Clients</div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default Services